import { render } from "./long-insure-add-subtract.vue?vue&type=template&id=673f57f6&scoped=true&ts=true"
import script from "./long-insure-add-subtract.vue?vue&type=script&lang=ts"
export * from "./long-insure-add-subtract.vue?vue&type=script&lang=ts"

import "./long-insure-add-subtract.vue?vue&type=style&index=0&id=673f57f6&lang=stylus&scoped=true"

import exportComponent from "C:\\work\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-673f57f6"]])

export default __exports__